import useShowAuthButtons from 'Hooks/useShowAuthButtons';
import LiveAgent from 'Lib/zendesk';

const LiveChatWrapper = props => {
  const { className, children, Node = 'div' } = props;

  const showLiveChatWrapper = useShowAuthButtons();

  if (!showLiveChatWrapper) return null;
  
  return (
    <Node
      className={className}
      onClick={() => {
        LiveAgent.openSupportChat();
      }}
    >
      {children}
    </Node>
  );
};

export default LiveChatWrapper;
